import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=31cf642e&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
import style0 from "./Activity.vue?vue&type=style&index=0&id=31cf642e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf642e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31cf642e')) {
      api.createRecord('31cf642e', component.options)
    } else {
      api.reload('31cf642e', component.options)
    }
    module.hot.accept("./Activity.vue?vue&type=template&id=31cf642e&scoped=true", function () {
      api.rerender('31cf642e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/auth/profile/components/Activity.vue"
export default component.exports